import { forwardRef, HTMLProps } from 'react';
import s from './print-container.module.css';
import cn from 'classnames';

// Здесь настраивать, чтобы параметры перешли в окно печати (браузерное)
export const PrintContainer = forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>(
  (props, ref) => {
    const { className, children, ...other } = props;

    return (
      <div ref={ref} className={cn(className, s.feature)} {...other}>
        <ul className={s.list}>{children}</ul>
      </div>
    );
  },
);
